import * as types from './actionType';
import asyncActionCreator from '../../../utils/asyncActionCreator';
import WEB_API from '../../../API/api'
let ActionTypes =types


const errorDutyRequest = () => ({
    type: ActionTypes.errorDutyRequest,
    payload: {}
});

const errorDutySuccess = (data) => ({
    type: ActionTypes.errorDutySuccess,
    payload: { data }
});

const errorDutyFailure = (error) => ({
    type: ActionTypes.errorDutyFailure,
    payload: { error }
});

export const getErrorDuty = (post_body,callback) => asyncActionCreator(
    WEB_API.GET_ERROR_DUTY,
    errorDutyRequest,
    errorDutySuccess,
    errorDutyFailure,
    'POST',
    post_body,
    false,
    callback
);



// WEBPACK FOOTER //
// ./src/entry_app/question_box/error_duty/action.js